import { render, staticRenderFns } from "./package-list-item.vue?vue&type=template&id=485bbb60"
import script from "./package-list-item.vue?vue&type=script&lang=js"
export * from "./package-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports